import React from 'react';

import styles from './RoleDisplay.module.scss';

export const RoleDisplay = ({ 
    role,
    title="ROLES",
    subtitle="",
    showId=true,
    border=true,
    maxWidth="250px",
    hover=false,
    alignment="center"
}) => {

    return(
        <div 
            style={{maxWidth: maxWidth}}
            className={`
                ${styles["role-display-wrapper"]}
                ${styles[border ? "border" : ""]}
                ${styles[hover ? "hover" : ""]}
            `}
        >
            {title &&
                <p className={styles["title"]}>ROLES</p>
            }
            {subtitle &&
                <p className={styles["subtitle"]}>{subtitle}</p>
            }
            <div className={`
                    ${styles["main-body"]}
                    ${alignment === "center" ? styles["center"] : ""}
                `}>
                <p>
                    <span className={styles["role-display"]} >
                        {showId ? `(${role?.id})` : null}{" "}
                        {role?.name} 
                    </span>
                </p>
            </div>
        </div>
    )

}